import { BehaviorSubject } from "rxjs";

export const ReloadPlanSubject = new BehaviorSubject(false);
